module.exports = __webpack_public_path__ + "img/icon-search.6143e4e1.svg";